import {Ease} from "../../core/Animatable";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class RotateAnimation extends Animation {

    private readonly rotation?: number;

    constructor(yoyo: number) {
        super();
        this.rotation = yoyo;
    }

    public animate(item: SceneItem, context: AnimationContext, cb: () => void): void {
        const time = this.time || 10;
        item.tweenTo(time, this.yoyo ? Ease.sineInOut : Ease.none, {
            rotation: this.yoyo ?
                item.rotation + Math.PI * (this.speed || 10) / 180 :
                !isNaN(this.rotation!) ? this.rotation! :
                    Math.PI * ((this.speed || 1) < 0 ? -2 : 2),
            delay: this.delay,
            repeat: this.repeat ? this.repeat < 1 ? 0 : this.repeat : -1,
            yoyo: this.yoyo,
            onUpdate: () => this.updatePaperCut(item),
            onStart: () => {
                if (!this.repeat) {
                    cb();
                }
            },
            onComplete: () => {
                if (this.repeat && this.yoyo && item.rotation !== 0) {
                    item.tweenTo(time, Ease.sineInOut, {
                        rotation: 0,
                        onUpdate: () => this.updatePaperCut(item),
                        onComplete: cb,
                    });
                } else if (this.repeat) {
                    cb();
                }
            },
        });
    }
}
